import type { FlashStatusType } from '@/Shared/AutoGenerated/Main'
import { ref } from 'vue'

const flashStatus = ref<FlashStatusType | null>(null)
const key = ref<number>(0)
const show = ref(false)

let timeoutHandler: number = -1

const hide = () => {
    clearTimeout(timeoutHandler)

    timeoutHandler = -1
    flashStatus.value = null
    show.value = false
}

const display = (newFlashStatus: FlashStatusType) => {
    hide()

    flashStatus.value = newFlashStatus
    show.value = true
    key.value += 1

    timeoutHandler = window.setTimeout(() => hide(), 5000)
}

export default function useFlash() {
    return {
        display,
        hide,
        flashStatus,
        key,
        show,
    }
}
